const topicItems = [
  { name: '热血江湖', heat: '9.8万', tag: '连载中' },
  { name: '异界幻想', heat: '9.5万', tag: '连载中' },
  { name: '恋爱百分百', heat: '8.9万', tag: '连载中' },
  { name: '深渊之眼', heat: '7.6万', tag: '连载中' },
  { name: '午夜画室', heat: '6.8万', tag: '连载中' },
  { name: '古风奇缘', heat: '6.3万', tag: '已完结' },
  { name: '校园日常', heat: '5.9万', tag: '连载中' },
  { name: '职场奋斗', heat: '5.4万', tag: '连载中' },
  { name: '末世生存', heat: '4.8万', tag: '连载中' },
  { name: '修真之路', heat: '4.2万', tag: '已完结' },
  { name: '电竞之王', heat: '3.9万', tag: '连载中' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          热门话题
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item, i) => (
            <div
              key={i}
              className="group inline-flex items-center gap-3 px-4 py-2.5 bg-background-50 rounded-full border border-background-200/70 hover:border-primary-300/60 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                #{item.name}
              </span>
              <span className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-fire-line text-accent-500 text-xs"></i>
                {item.heat}
              </span>
              <span
                className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                  item.tag === '连载中'
                    ? 'bg-accent-100 text-accent-700'
                    : 'bg-secondary-100 text-secondary-700'
                }`}
              >
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}